import ManagerInsights from "./ManagerInsights"

function Analytics() {
  
  return (
    <div className="relative flex min-h-[calc(100vh-3.5rem)]">
      <ManagerInsights /> 
    </div>
  )
}

export default Analytics
